const pacmanYellow = `hsl(57deg 96% 60%)`;
const pacmanPink = `hsl(319deg 53% 66%)`;
const pacmanGreen = `hsl(95deg 60% 47%)`;
const pacmanOrange = `hsl(24deg 74% 51%)`;
const white = `hsl(60deg 10% 85%)`;
const black = "var(--black)";
// const grey = `hsl(60deg 5% 45%)`;
const grey = `hsl(240deg 5% 45%)`;
const transparentBannerRed = `hsl(0deg 55% 45% / 0.75)`;
// const grey = `hsl(240deg 5% 35% / 0.8)`;

export const COLORS = {
  pacmanYellow,
  pacmanPink,
  pacmanGreen,
  pacmanOrange,
  white,
  black,
  grey,
  transparentBannerRed,
};
